<app-metric-card
  class="coverage-card clickable-card"
  [title]="'Configuration Status'"
  [currentValue]="configStatus()?.config_status ?? ''"
  [hideComparison]="true"
  [hidePrevious]="true"
  [suffix]="''"
  [showLeftBorder]="showBorder()"
  [leftBorderColor]="leftBorderColor()"
  [showLastUpdated]="true"
  [lastUpdatedDate]="configStatus()?.last_updated ?? null"
  [lastUpdatedLabel]="'Last updated:'"
  (click)="onCardClick()"
></app-metric-card>

<!-- Configuration Details Dialog -->
<app-es-config-details-dialog
  [isVisible]="isDialogVisible()"
  [configurationData]="configurationDetails()"
  [isLoading]="isLoadingDetails()"
  (onSave)="onSaveChanges($event)"
  (onCancel)="onDialogClose()"
></app-es-config-details-dialog>
